export default "__VITE_ASSET__B5BsbcyP__"